class QuantityBoxes extends HTMLElement {
  constructor() {
    super();
    this.quantityInput = null;
  }

  connectedCallback() {
    const form = this.closest("form");
    if (!form) return;

    this.quantityInput = form.querySelector('input[name="quantity"]');
    if (!this.quantityInput) return;

    const boxes = this.querySelectorAll(".quantity-box");
    boxes.forEach((box) => {
      box.addEventListener("click", this.#handleBoxClick.bind(this));
    });

    this.#syncActiveFromInput();
  }

  #handleBoxClick(event) {
    const box = event.currentTarget;
    const quantity = box.getAttribute("data-quantity");
    if (!quantity || !this.quantityInput) return;

    this.quantityInput.value = quantity;
    this.quantityInput.dispatchEvent(new Event("change", { bubbles: true }));

    this.#setActiveBox(box);
  }

  #setActiveBox(activeBox) {
    const boxes = this.querySelectorAll(".quantity-box");
    boxes.forEach((box) =>
      box.classList.toggle("quantity-box--active", box === activeBox)
    );
  }

  #syncActiveFromInput() {
    const value = this.quantityInput?.value;
    if (value == null) return;

    const boxes = this.querySelectorAll(".quantity-box");
    const matching = Array.from(boxes).find(
      (box) => box.getAttribute("data-quantity") === String(value)
    );
    if (matching) this.#setActiveBox(matching);
  }
}

if (!customElements.get("quantity-boxes")) {
  customElements.define("quantity-boxes", QuantityBoxes);
}
